export default "__VITE_ASSET__23df2525__"